import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationAttachAuthorizedSetupIntent({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      memberId,
      setupIntentId,
    }: {
      memberId: string;
      setupIntentId: string;
    }) => {
      return (
        await api.memberApi.attachAuthorizedSetupIntent(memberId, setupIntentId)
      ).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: memberQueryKeys.all() });
    },
  });
}
